import miscApi from 'api/miscApi';

const miscHelper = {
  callApiUploadFile: async (file) => {
    const res = await miscApi.uploadFile(file);
    const { result, media } = res;
    if (result === 'success' && media) {
      return media;
    }
    return [];
  },

  callApiGetAppConfig: async () => {
    const res = await miscApi.getConfig();
    const { result, config, operators, services } = res;
    if (result === 'success' && config && operators && services) {
      return { config, operators, services };
    }
    return [];
  },

  callApiGetBankList: async () => {
    const res = await miscApi.getBanksList();
    const { result, banks } = res.data;
    if (result === 'success' && banks) {
      return banks;
    }
    return [];
  },

  callApiUpdateConfig: async (params) => {
    const res = await miscApi.addConfig(params);
    const { result } = res;
    if (result === 'success') {
      return true;
    }
    return false;
  },
};

export default miscHelper;
